export const getBrands = productAttributes => {
  const brandAttribute = productAttributes === null || productAttributes === void 0 ? void 0 : productAttributes.find(productAttribute => productAttribute.name === 'brand');
  const values = brandAttribute === null || brandAttribute === void 0 ? void 0 : brandAttribute.values;
  return values ? values.map(value => value.name).join(',') : '';
};